<template>
  <div>
    <div id="elfinderContract"></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "ManagerContractsFolder",
  data() {
    return {
      loading: false,
      userId: this.$route.query.user_id
    };
  },
  mounted() {
    this.initElfinderContract();
  },
  methods: {
    async initElfinderContract() {
      // ✅ Tải jQuery, jQuery UI, elFinder (nếu chưa có)
      await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js");
      await this.loadCSS("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.13.2/themes/smoothness/jquery-ui.min.css");
      await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.13.2/jquery-ui.min.js");
      await this.loadCSS("https://cdnjs.cloudflare.com/ajax/libs/elfinder/2.1.65/css/elfinder.min.css");
      await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/elfinder/2.1.65/js/elfinder.min.js");

      // ✅ Sau khi đã load xong, khởi tạo elFinder
      $('#elfinderContract').elfinder({
        url: `${process.env.VUE_APP_API_URL}/elfinder/connector/contract?user_id=${this.userId}`,
        customData: { type: 'contract' },
        height: 500,
        resizable: false,
        requestType: 'post',
        rememberLastDir: false,
        handlers: {
          init: function (event, elfinderInstance) {
            elfinderInstance.id = 'elfinderContract';
          }
        },
      });
    },

    // 🧩 Tải script động
    loadScript(src) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve();
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    // 🧩 Tải CSS động
    loadCSS(href) {
      return new Promise((resolve) => {
        if (document.querySelector(`link[href="${href}"]`)) return resolve();
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
        resolve();
      });
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    ...mapGetters(["currentUser"])
  }
};
</script>

<style scoped>
</style>
